







































































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/shared/Header.vue';
import ICountUp from 'vue-countup-v2';

interface UserData {
  blogList: Array<object>;
  blogUrl: string;
  name: string;
  updateTime: string;
}

@Component({
  name: 'Index',
  components: {
    Header,
    ICountUp,
  },
})
export default class Index extends Vue {
  private data: Array<UserData> = [];

  private isLoading = true;

  private delay = 1000;

  private ICountUpOptions = {
    people: 0,
    article: 0,
    public: 0,
    private: 0,
  };

  private copper = 0;

  private silver = 0;

  private gold = 0;

  private noPrize = 0;

  private getData(): void {
    this.isLoading = true;
    this.axios.get(process.env.VUE_APP_DATAURL).then((res) => {
      this.data = res.data;
      this.getArticle();
      this.getAwarded();
    });
  }

  private getAwarded(): void {
    this.data.forEach((data) => {
      const leng: number = data.blogList.length;
      // 由於得獎是每一個獎項都會得獎
      // 所以當到達特定範圍時每一個獎狀都會增加
      this.copper += leng >= 10 ? 1 : 0;
      this.silver += leng >= 25 ? 1 : 0;
      this.gold += leng >= 40 ? 1 : 0;
      this.noPrize += leng < 10 ? 1 : 0;
    });
  }

  private getArticle(): void {
    const articleArray: Array<object> = [];
    const cachePublic: Array<UserData> = [];
    const cachePrivate: Array<UserData> = [];

    this.data.forEach((data) => {
      const { blogList } = data;
      blogList.forEach((item) => {
        articleArray.push(item);
      });
    });

    this.data.forEach((data) => {
      if (data.name !== null) {
        cachePublic.push(data);
      } else {
        cachePrivate.push(data);
      }
    });

    this.ICountUpOptions.people = this.data.length;
    this.ICountUpOptions.article = articleArray.length;
    this.ICountUpOptions.public = cachePublic.length;
    this.ICountUpOptions.private = cachePrivate.length;

    this.isLoading = false;
  }

  public created(): void {
    this.getData();
  }
}
